import { z } from 'zod';

/** Draft graph node — id + type required; rest is engine-specific. */
export const workflowTemplateDraftNodeSchema = z
    .object({
        id: z.string().min(1),
        type: z.string().min(1),
    })
    .passthrough();

export const workflowTemplateDraftEdgeSchema = z
    .object({
        id: z.string().min(1),
    })
    .passthrough();

/**
 * Workflow template payload as edited in the designer.
 * Graph fields stay permissive; identity fields must match Mongoose requirements.
 */
export const workflowTemplateDraftSchema = z
    .object({
        code: z.string().trim().min(1, 'Kod zorunludur'),
        name: z.string().trim().min(1, 'Ad zorunludur'),
        entityType: z.string().trim().min(1, 'Entity tipi zorunludur'),
        nodes: z.array(workflowTemplateDraftNodeSchema).optional(),
        edges: z.array(workflowTemplateDraftEdgeSchema).optional(),
        notifications: z.record(z.string(), z.any()).optional(),
        variables: z.array(z.any()).optional(),
        rejectionRoutes: z.array(z.any()).optional(),
        compensationMap: z.record(z.string()).optional(),
    })
    .passthrough();

export function safeParseWorkflowTemplateDraft(input) {
    return workflowTemplateDraftSchema.safeParse(input);
}

export function formatWorkflowDraftZodIssues(issues) {
    if (!issues?.length) return '';
    return issues.map((e) => `${e.path.length ? e.path.join('.') : 'root'}: ${e.message}`).join('; ');
}
